/*!
 * MLE.Client.Components.Frontpage.Static
 * File: frontpage.static.js
 * Copyright (c) 2025 Runtime Software Development Inc.
 * Version 2.1
 * MIT Licensed
 */

import React from 'react';


/**
 * MLE viewer welcome message.
 *
 * @public
 */

export const viewerWelcome = <>
    <p>
        The Mountain Legacy Project (MLP) explores changes in Canada’s mountain
        landscapes through the world’s largest collection of systematic
        high-resolution historic mountain photographs.
    </p>

    <p>
        Explorer is a map-based tool for browsing the MLP collection and viewing historic
        and their repeat (modern) survey images. Use the navigator panel on the left to explore the collection.</p>
    <p>
        All images are available under a Creative Commons license, which means
        you can copy, print, and share for personal, non-commercial interests.
        If you intend to use images in publications or other media, including websites,
        please <a href={"mailto:mntnlgcy@uvic.ca"}><strong>drop us a note</strong></a> to
        let us know about this &mdash; it’s wonderful to see the images used and enjoyed.
    </p>
    <p>
        For more information
        about the project, visit <a
        target={'_blank'}
        rel={'noreferrer'}
        href={'http://www.mountainlegacy.ca'}>mountainlegacy.ca</a>.
    </p>
</>;
